<template>
    <div class="cart__block">
        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :is-full-page="fullPage">

        </loading>
        <div
                v-cloak
                v-for="cartitem in this.$store.getters.cartitems"
                :key="cartitem.id"
                class="cart__item"
        >
            <a class="cart__item-remove" v-on:click="removeItem(cartitem.id, $event)" href="#">
                <svg class="cart__item-remove-icon" width="15" height="15">
                    <use xlink:href="#icon-cross"></use>
                </svg></a>
            <cart-list-item-service v-if="cartitem.product_id===15212"
                                    :cartitem="cartitem"
            ></cart-list-item-service>
            <cart-list-item v-else
                            :cartitem="cartitem"
            ></cart-list-item>
            <div v-if="cartitem.product_id!==15212" class="cart__item-line cart__item-line--2">
                <cart-item-quantity
                        v-bind:cart_item_id="cartitem.id"
                ></cart-item-quantity>
            </div>
        </div>
    </div>
</template>

<script>
    import CartListItem from './cart-list-item'
    import CartListItemService from './cart-list-item-service'
    import CartItemQuantity from './cart-item-quantity'
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: "cart-list",
        components: {
            CartListItem,
            CartListItemService,
            CartItemQuantity,
            Loading
        },
        data() {
            return {
                fullPage: true
            }
        },
        methods: {
            removeItem (item, e) {
                e.preventDefault();
                this.$store.dispatch('removeItem', item)
                this.$root.$emit('SomethingChangedInCart');
            }
        },
        computed: {
            isLoading() {
                return this.$store.getters.loading;
            }
        }
    }
</script>

<style scoped>

</style>
